import React, { PropTypes as T } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

const style = {
  paddingTop: 5,
};

export default class Dropdown extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      open: false,
    };
  }

  toggleDropdown() {
    if (this.state.open) {
      this.setState({ open: false });
    } else {
      this.setState({ open: true });
    }
  }

  handleClick(event) {
    const clickArea = ReactDOM.findDOMNode(this.refs.dropdown);
    if (this.state.open && clickArea) {
      const isClickInside = clickArea.contains(event.target);
      if (!isClickInside) {
        this.setState({ open: false });
      }
    }
  }

  returnClassNames() {
    return `dropdown ${this.props.align}`;
  }

  componentDidMount() {
    window.addEventListener('click', this.handleClick.bind(this));
  }

  componentWillUnmount() {
    window.addEventListener('click', this.handleClick.bind(this));
  }

  feedback = ({ action, campaignType }) => {
    if (typeof this.props.onClick === 'function') {
      this.props.onClick({ action, campaignType });
    }
  }

  render() {
    const {
      align,
      dropdownStyle,
      colour,
      shouldRenderNodes,
      contentNodes,
    } = this.props;
    const alignName = align && `open-${align}`;
    const dropdownClassName = `${dropdownStyle || 'dropdown'} ${alignName}`;
    return (
      <div style={style} className={dropdownClassName} ref="dropdown">
        <span className="dropdown-selector" onClick={this.toggleDropdown.bind(this)} >
          {this.props.children}
        </span>
        <div className={this.state.open ? 'dropdown-area visible' : 'dropdown-area'} >
          <div className="arrow" />
          <div className="wrapper" onClick={this.toggleDropdown.bind(this)}>
            <div className="dropdown-content">
              {
                shouldRenderNodes && contentNodes
              }
              {
                !shouldRenderNodes &&
                <ul>
                  { this.props.content &&
                    <div>
                      { this.props.content.map(item => {
                        const generatedKey = `${Math.random()}-${item.name}`;
                        const { name, action, campaignType } = item;
                        return (
                          <span key={generatedKey}>
                            {
                              name && action &&
                              <li className={colour || ''} onClick={_.isFunction(item.action) ? item.action : () => this.feedback({ action, campaignType })}>
                                <p>{name}</p>
                              </li>
                            }
                          </span>
                        );
                      })}
                    </div>
                  }
                </ul>
              }
            </div>
            { this.props.buttonText && this.props.buttonLink &&
              <div className="dropdown-button">
                <div className="button-inner" onClick={() => this.context.router.push(this.props.buttonLink)} >
                  <p className="small">{ this.props.buttonText }</p>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

Dropdown.propTypes = {
  feedback: React.PropTypes.func,
};



/** WEBPACK FOOTER **
 ** ./src/components/dropdown/index.js
 **/